import AngleDown from "icons/planning/angle-down.svg";
import AngleLeft from "icons/planning/angle-left.svg";
import React, { useState } from "react";

export default function WithToggle(props) {
    const [opened, setOpened] = useState(true);
    return (
        <>
            <div
                className="p-expanded__card-subtitle d-flex justify-content-between cursor-pointer"
                onClick={() => setOpened(!opened)}
            >
                {props.title}
                {opened ? <AngleDown /> : <AngleLeft />}
            </div>
            {opened && props.children}
        </>
    );
}
